<div *ngFor="let option of optionsList">
  <p class="text-white text-right secondary-paragraph mb-2">
    <img (click)="doAction(option.id)" class="cursor-pointer" [src]="option.img" alt="icon" width="40" height="40">
  </p>
</div>
<div *ngIf="storyType != Story_Type.TEMPLATE" class="d-flex justify-content-end text-white text-right">
  <span class="backgroundColour"  [ngStyle]="{'background-image': 'linear-gradient(' + backGroundGradient + ')'}" (click)="changeBackGroundColour()"></span>
</div>
